import { Button, Modal } from "@/shared/ui";

import CardSuccessImg from "@/assets/images/card-success.png";

interface IProps {
    open: boolean;
    onContinue(): void;
};

const AddCardSuccess = ({ open, onContinue }: IProps) => (
    <Modal
        open={open}
        contentClassName="sm:max-w-[350px] !px-[1.25rem] !py-[1.5625rem]"
        defaultContentSizes={false}
        onClose={onContinue}
    >
        <div className="items-centers flex flex-col">
            <img width={100} src={CardSuccessImg} alt="" className="mx-auto w-[6.125rem] mb-[1.0625rem] sm:mb-[1.25rem]" />

            <h2 className="w-full text-[1.5625rem] text-center mb-[0.625rem] font-agrandir leading-[130%]">
                Your card has been
                <br />
                added successfully!
            </h2>

            <p className="w-full font-atkinsonHyperlegible text-center mb-5 text-15 leading-[130%]">
                If you have a copay or OTC purchase, your card will only be charged after your prescriptions have shipped
            </p>

            <Button
                showEndIcon
                onClick={onContinue}
                fontClassName="font-atkinsonBold"
            >
                <span>Continue</span>
            </Button>
        </div>
    </Modal>
);

export default AddCardSuccess;